export const types = {
  storage: {
    banksStore: '@uyyrsahfdv_storage_Banks',
    userStorage: '@QJ45w9vZsed_storage_User',
    tokenStorage: '@UW75a2bAsdx_storage_Token',
    permissionsStorage: '@d943yg78eygx_storage_Permissions',
    userPermissionsStorage: '@s83hjhs8sghg_storage_user_Permissions',
    logsStorage: '@iouiasdfghgv_storage_logs',
    epsStorage: '@hdurjtisod_storage_eps',
    familyCompensationFund: '@uyrhgjshfdgf_storage_family_compensation_fund',
    tipoNovedadesStorage: '@oiurjkff_storage_tipo_novedades',
    hasUpdatesStorage: '@ks8df3n8_storage_hasUpdates',
    newsUpdatedStorage: '@nwsupd93j_storage_newsUpdated',
  },
};
